module.exports = __webpack_public_path__ + "static/media/logo4.a1f68865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo4.jpg
// module id = 10
// module chunks = 0